import React from 'react';
import { useHistory } from 'react-router-dom';

import TableHeader from '../../../../../components/Table/TableHeader';
import TablePagination from '../../../../../components/Table/TablePagination';
import FormControl from '@material-ui/core/FormControl';
import InputSearch from '../../../../../components/InputSearch';

const tabelaColunas = ['# ID', 'Tipo', 'Razão Social', 'Nome Fantasia', 'CNPJ',  'UF', 'Cidade', 'Status', ''];

const ListCd = ({ 
    data,
    buscar,
    busca,
    mudarPagina,
    chamarForm,
    gerarExcel
}) => {
    const history = useHistory();

    const changePage = (page) => {
        mudarPagina(page)   
    }

    return (
        <div className="ml-1 mt20">
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <h1 className='label-second'>Lojas e CDs Cadastrados</h1>
                </div>
            </div>
            <div className='row mt20'>
                <div className='col-sm-3 col-md-3 col-lg-3'>
                    <button 
                        onClick={() => chamarForm(6)} className="buton-green btn btn-block btn-lg mt20"
                    >
                        CADASTRAR LOJA / CD
                    </button>
                </div>

                <div className='col-sm-3 col-md-3 col-lg-3'>
                    <button 
                        className="buton-white-black-border btn btn-block btn-lg mt20"
                        onClick={gerarExcel}
                    >
                        EXTRAIR BASE
                    </button>
                </div>
            </div>
            <div className="row justify-content-end">
                <div className='col-md-3'>
                    <FormControl>
                        <InputSearch
                            buscar={buscar}
                            buscaPor={busca}
                        />
                    </FormControl>
                </div>
            </div>
            <div className="row">
                    <div className='col-12 mt20'>
                        <div className="table-responsive">
                            <table className="table">
                                <TableHeader columns={tabelaColunas} />

                                <tbody>
                                    {
                                        (!data || !data?.lista || data?.lista.length === 0) &&
                                        <tr><td colSpan="7"> Sem Registros </td></tr>
                                    }
                                    {
                                        data.lista  && data.lista.map((cdBuyer) => (
                                            <tr key={cdBuyer.id}>
                                                <td> {cdBuyer.codigo.toString().padStart(6, '0')} </td>
                                                <td> {cdBuyer.dadosCadastrais.tipo} </td>
                                                <td> {cdBuyer.razaoSocial} </td>
                                                <td> {cdBuyer.nomeFantasia} </td>
                                                <td> {cdBuyer.cnpj} </td>
                                                <td> {cdBuyer.estado} </td>
                                                <td> {cdBuyer.cidade} </td>
                                                <td> {cdBuyer.ativo ? 'Ativo' : 'Inativo'} </td>
                                                <td className="text-right">
                                                    <i className="btn-edit-icon btn btn-icon fa fa-edit" onClick={() => chamarForm(6, cdBuyer.id)}></i>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                            <TablePagination data={data} changePage={changePage} />
                        </div>
                    </div>
                </div>
        </div>
    )
}

export default ListCd;